import React, { memo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import TransitionButton from '../molecules/TransitionButton';
import { mypage_url } from '../Const';
import { releaseBrowserBack, banBrowserBack } from '../BrowserBack';
import Popup from '../molecules/Popup';

interface Props {
  is_change: boolean; // 借入申込変更
  movePrevStep: () => void;
  handleClickNext: () => Promise<any>; // 「次へボタン」のアクション
  handleClickTempSave: () => Promise<any>; // 「一時保存」のアクション
  handleClickDecline: () => Promise<any>; // 「辞退する」のアクション
  handleClickChangeDetails: () => Promise<any>; // 「申込内容を変更する」のアクション
  reception_cd: string;
  reception_id: number;
  moveNextStep: VoidFunction;
  setDisplayStatus: (flag: boolean) => void;
  status_code: number;
}

// KWANKGM04030_借入申込入力（確認）
// KWANKGM04120_農業資金借入申込入力（確認）
const FooterBorrowingApplicationInputConfirmation: React.FC<Props> = ({
  is_change,
  movePrevStep,
  handleClickNext,
  handleClickTempSave,
  handleClickDecline,
  handleClickChangeDetails,
  reception_cd,
  reception_id,
  moveNextStep,
  setDisplayStatus,
  status_code,
}) => {
  const [modal_decline_open, setModalDeclineOpen] = useState(false);
  const [modal_temp_save, setModalTempSave] = useState(false);
  const [modal_change_details, setModalChangeDetails] = useState(false);
  const history = useHistory();

  // 次へボタン押下時のアクション
  const clickNext = async () => {
    const result = await handleClickNext();
    if (result) {
      moveNextStep();
      setDisplayStatus(false);
      history.push(`/reception/${reception_cd}/${reception_id}/${status_code}/complete`);
    }
  };

  // モーダル内の「辞退する」押下時処理
  const clickDecline = async () => {
    // 辞退するのAPI処理（CommonAPIをキックする）
    setModalDeclineOpen(false);
    const result = await handleClickDecline();
    if (result) {
      history.push(`/reception/${reception_cd}/${reception_id}/${status_code}/complete`);
    }
  };

  // 変更モーダル押下時処理
  const clickChange = async () => {
    // 「申込内容を変更する」の処理（CommonAPIをキックする）
    const result = await handleClickChangeDetails();
    if (result) {
      setModalChangeDetails(false);
    }
  };

  //「一時保存する」押下時のイベントハンドラ
  const handleClickOpenTempSave = async () => {
    // 一時保存の処理（CommonAPIをキックする）
    const result = await handleClickTempSave();
    if (result) {
      setModalTempSave(true);
    }
  };

  /**
   * 一つ前の画面に遷移
   */
  const handleClickReturn = () => {
    movePrevStep();
    releaseBrowserBack();
    history.goBack();
    banBrowserBack();
  };

  return (
    <>
      {!is_change && (
        <Row className="mt-5">
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <p>
              連帯債務者などの方(連帯債務・連帯保証で設定している方)にこの借入についてあらかじめ連絡しておいて下さい。
              <br />
              「次へ進む」ボタンを押すと連帯債務者などの方に申込内容確認のためのメールが送信されます。
            </p>
          </Col>
        </Row>
      )}
      <Row
        className={`mt-5 ${!is_change &&
          'flex-lg-row flex-md-reverse flex-sm-column-reverse flex-column-reverse'}`}
      >
        <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-left-button-no-arrow">
          <div className="text-left sp-button-center">
            <a className="btn btn-xl btn-main-color" onClick={handleClickOpenTempSave}>
              一時保存する
            </a>
          </div>
        </Col>
        <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-right-button-small">
          <div className="text-right sp-button-center">
            <a className="btn btn-xl btn-main-color ml-auto" onClick={clickNext}>
              次へ進む
            </a>
          </div>
        </Col>
      </Row>
      <TransitionButton label="戻る" handleClick={handleClickReturn} />
      <Popup
        title="借入申込の辞退確認"
        text="申込の辞退となりますが、よろしいですか？"
        first_button={{
          label: '辞退する',
          variant: 'danger',
          handleClick: () => {
            clickDecline;
          },
        }}
        second_button={{
          label: '戻る',
          variant: 'outline-success',
          handleClick: () => {
            setModalDeclineOpen(false);
          },
        }}
        toggleClose={() => setModalDeclineOpen(false)}
        toggleShow={modal_decline_open}
      />
      <Popup
        title="一時保存完了"
        text="入力内容を一時保存しました。このまま入力を続けますか？"
        first_button={{
          label: '入力を続ける',
          variant: 'success',
          handleClick: () => setModalTempSave(false),
        }}
        second_button={{
          label: 'マイページへ戻る',
          variant: 'outline-success',
          handleClick: () => {
            setModalTempSave(false);
            location.href = mypage_url;
          },
        }}
        toggleClose={() => setModalTempSave(false)}
        toggleShow={modal_temp_save}
      />
      <Popup
        title="申込内容の変更"
        text="申込内容を変更できる状態に戻します。よろしいですか？"
        first_button={{
          label: '申込内容を変更する',
          variant: 'success',
          handleClick: () => {
            clickChange;
          },
        }}
        second_button={{
          label: '戻る',
          variant: 'outline-success',
          handleClick: () => {
            setModalChangeDetails(false);
          },
        }}
        toggleClose={() => setModalChangeDetails(false)}
        toggleShow={modal_change_details}
      />
    </>
  );
};

export default memo(FooterBorrowingApplicationInputConfirmation);
